export default "__VITE_ASSET__CpEef0TM__"